import React, { useState } from 'react';
import { Search, Users, User, FileText, Home, Globe, CreditCard, Car, Heart, Grid, DollarSign, Smartphone } from 'lucide-react';
export const Help = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const helpCategories = [{
    id: 1,
    title: 'General Information',
    icon: <FileText className="h-8 w-8 text-blue-500" data-id="element-422" />,
    description: 'Learn about the eServices platform functionality, digital certificates, and electronic documentation.'
  }, {
    id: 2,
    title: 'Account',
    icon: <User className="h-8 w-8 text-blue-500" data-id="element-423" />,
    description: 'Discover everything about setting up and maintaining your eServices user profile.'
  }, {
    id: 3,
    title: 'Media Reach',
    icon: <Globe className="h-8 w-8 text-blue-500" data-id="element-424" />,
    description: 'This section covers media resources, communication channels, and usage guidelines.'
  }, {
    id: 4,
    title: 'Civil Registry',
    icon: <Users className="h-8 w-8 text-blue-500" data-id="element-425" />,
    description: 'Details about matrimony, birth registration, family documentation and other household-related services available through eServices.'
  }, {
    id: 5,
    title: 'Immigration and Residency',
    icon: <Globe className="h-8 w-8 text-blue-500" data-id="element-426" />,
    description: 'Details about nationality, travel authorization applications, residence documentation and additional services offered by NISS.'
  }, {
    id: 6,
    title: 'Identification',
    icon: <CreditCard className="h-8 w-8 text-blue-500" data-id="element-427" />,
    description: 'Details about identity verification services, National ID applications, information updates and replacement procedures administered by NIRA.'
  }, {
    id: 7,
    title: 'Land Services',
    icon: <Home className="h-8 w-8 text-blue-500" data-id="element-428" />,
    description: 'Details about property services, mapping resources, real estate documentation, and additional services managed by NLMA.'
  }, {
    id: 8,
    title: 'Transport',
    icon: <Car className="h-8 w-8 text-blue-500" data-id="element-429" />,
    description: 'Details about operator permits, vehicle registration, safety evaluations and additional automotive-related services.'
  }, {
    id: 9,
    title: 'Health',
    icon: <Heart className="h-8 w-8 text-blue-500" data-id="element-430" />,
    description: 'Details about wellness, digital medical documentation, telemedicine options and healthcare coverage plans.'
  }, {
    id: 10,
    title: 'Other Services',
    icon: <Grid className="h-8 w-8 text-blue-500" data-id="element-431" />,
    description: 'Details about background verification, official documentation, utility connections, legal authentication, public assistance and additional services through eServices. Additional resources available in linked documentation.'
  }, {
    id: 11,
    title: 'Payment center',
    icon: <DollarSign className="h-8 w-8 text-blue-500" data-id="element-432" />,
    description: 'A complete guide for making protected digital transactions, reimbursements, payment records, and resolving issues across various government platforms for paid services.'
  }, {
    id: 12,
    title: 'Educational Services',
    icon: <FileText className="h-8 w-8 text-blue-500" data-id="element-433" />,
    description: 'Access information about educational certificates, scholarship applications, school registrations, and other learning-related government services.'
  }];
  const filteredCategories = searchQuery ? helpCategories.filter(category => category.title.toLowerCase().includes(searchQuery.toLowerCase()) || category.description.toLowerCase().includes(searchQuery.toLowerCase())) : helpCategories;
  return <div className="min-h-screen bg-gray-50" data-id="element-434">
      {/* Hero section with search */}
      <div className="relative bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20" data-id="element-435">
        <div className="absolute inset-0 bg-black opacity-50 z-0" data-id="element-436"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-437">
          <div className="max-w-3xl mx-auto text-center" data-id="element-438">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-439">
              How can we help you today?
            </h1>
            <p className="text-blue-100 mb-8" data-id="element-440">
              Find knowledge base content for the eServices Institution here.
            </p>
            <div className="flex max-w-xl mx-auto" data-id="element-441">
              <div className="relative flex-grow" data-id="element-442">
                <input type="text" placeholder="Enter your search term here..." className="w-full pl-4 pr-10 py-3 rounded-l-md text-gray-800 focus:outline-none" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-443" />
                <Search className="absolute right-3 top-3 h-5 w-5 text-gray-400" data-id="element-444" />
              </div>
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-r-md transition-colors" data-id="element-445">
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Help categories grid */}
      <div className="container mx-auto px-4 py-16" data-id="element-446">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-447">
          {filteredCategories.map(category => <div key={category.id} className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow cursor-pointer border border-gray-100 group" data-id="element-448">
              <div className="flex items-center justify-center mb-4 bg-blue-50 w-16 h-16 rounded-full mx-auto group-hover:bg-blue-100 transition-colors" data-id="element-449">
                {category.icon}
              </div>
              <h3 className="text-lg font-semibold text-center mb-3" data-id="element-450">
                {category.title}
              </h3>
              <p className="text-gray-600 text-sm text-center" data-id="element-451">
                {category.description}
              </p>
              <div className="mt-4 text-center" data-id="element-452">
                <span className="text-blue-600 text-sm hover:underline inline-flex items-center justify-center px-3 py-1 rounded-full bg-blue-50 group-hover:bg-blue-100 transition-colors" data-id="element-453">
                  View articles
                </span>
              </div>
            </div>)}
        </div>
        {filteredCategories.length === 0 && <div className="text-center py-12" data-id="element-454">
            <p className="text-gray-500 text-lg" data-id="element-455">
              No results found for "{searchQuery}"
            </p>
            <button onClick={() => setSearchQuery('')} className="mt-4 text-blue-600 hover:text-blue-800" data-id="element-456">
              Clear search
            </button>
          </div>}
      </div>
    </div>;
};